export default "__VITE_ASSET__246ba6a2__"